export type EnquiryCardQuoteActions = {
  showViewQuote: boolean;
  showEditQuote: boolean;
  viewQuoteLabel: string;
  editQuoteLabel: string;
};

export const DEFAULT_ENQUIRY_CARD_QUOTE_ACTIONS: EnquiryCardQuoteActions = {
  showViewQuote: true,
  showEditQuote: true,
  viewQuoteLabel: 'View quote',
  editQuoteLabel: 'Edit quote',
};

export function parseEnquiryCardQuoteActions(
  raw: unknown,
  fallback: EnquiryCardQuoteActions = DEFAULT_ENQUIRY_CARD_QUOTE_ACTIONS,
): EnquiryCardQuoteActions {
  if (!raw || typeof raw !== 'object') return fallback;
  const value = raw as Record<string, unknown>;
  return {
    showViewQuote: value.show_view_quote === false ? false : fallback.showViewQuote,
    showEditQuote: value.show_edit_quote === false ? false : fallback.showEditQuote,
    viewQuoteLabel:
      String(value.view_quote_label ?? fallback.viewQuoteLabel).trim() || fallback.viewQuoteLabel,
    editQuoteLabel:
      String(value.edit_quote_label ?? fallback.editQuoteLabel).trim() || fallback.editQuoteLabel,
  };
}

export function serializeEnquiryCardQuoteActions(value: EnquiryCardQuoteActions) {
  return {
    show_view_quote: value.showViewQuote,
    show_edit_quote: value.showEditQuote,
    view_quote_label: value.viewQuoteLabel,
    edit_quote_label: value.editQuoteLabel,
  };
}

export function resolveEnquiryCardQuoteActions(input: {
  orgSettings?: Record<string, unknown> | null;
  platform?: EnquiryCardQuoteActions;
}): EnquiryCardQuoteActions {
  const platform = input.platform ?? DEFAULT_ENQUIRY_CARD_QUOTE_ACTIONS;
  const orgRaw = input.orgSettings?.enquiry_card_quote_actions;
  if (orgRaw == null) return platform;
  return parseEnquiryCardQuoteActions(orgRaw, platform);
}
